import React from 'react';
import Drawer from '@/components/Drawer';
import { Button, Space } from 'antd';
import { useDispatch, useSelector } from 'umi';
import { F } from '@/utils/intl';
import * as HelpSelectors from '@/selectors/helpSelectors';
import isEmpty from 'lodash/isEmpty';

const HelpArticleDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const articleDrawer = useSelector(HelpSelectors.selectHelpArticleDrawer)
  const open = !isEmpty(articleDrawer)
  const toggle = () => {
    dispatch({
      type: 'help/toggleHelpArticleDrawer'
    })
  }
  function getFooter() {
    return (
      <div style={{textAlign: 'right'}}>
        <Space>
          <Button
            className={'button-secondary button-bordered'}
            size={'large'}
            type={'primary'}
            onClick={toggle}
          >
            <F id={'common.actions.close'} defaultMessage={'Close'}/>
          </Button>
        </Space>
      </div>
    )
  }

  const renderMockArticle = () => {
    return null
  }

  return (
    <Drawer
      width={800}
      title={'Help Center'}
      open={open}
      onOpenChange={toggle}
      footer={getFooter()}
      destroyOnHidden
    >
      {renderMockArticle()}
    </Drawer>
  );
};

export default HelpArticleDrawer;
